export default __webpack_public_path__ + "static/media/prev-clicked-green.65042bc3.svg";